export default __webpack_public_path__ + "b9e676bcd0924c40209a35fde3f8f6ea.woff2";